import { useState } from "react";
import {
  ICredentialsAndreaniErrors,
  ICredentialsAndreaniPayload,
  ICredentialsStep,
} from "../../../interfaces/configuration";
import { validateInputs } from "../../../utils/inputValidations";
import { ERRORS_MESSAGES } from "../../../utils/constants";
import { Typography } from "@mui/material";
import { IValidation } from "../../../interfaces/form";
import GenericAlert from "../../GenericAlert";
import ConfirmChangesCredentials from "../ConfirmChangesCredentials";
import CredentialsAndreani from "../../forms/CredentialsAndreani";

const {
  passwordRequired,
  idClientRequired,
  userRequired,
  doorToDoorRequired,
  endDateRequired,
  endDateNotInThePast,
  doorToDoorOnlyNumbers,
  pickupOnlyNumbers,
  reverseOnlyNumbers,
  reverseRequired,
  oneDoorToDoorRequired,
} = ERRORS_MESSAGES;

const formValidations: IValidation[] = [
  {
    id: "client",
    type: "required",
    message: idClientRequired,
  },
  {
    id: "user",
    type: "required",
    message: userRequired,
  },
  {
    id: "password",
    type: "required",
    message: passwordRequired,
  },
  {
    id: "b2c",
    type: "only-numbers",
    message: doorToDoorOnlyNumbers,
  },
  {
    id: "b2c",
    type: "required",
    message: doorToDoorRequired,
  },
  {
    id: "b2b",
    type: "only-numbers",
    message: doorToDoorOnlyNumbers,
  },
  {
    id: "pickup",
    type: "only-numbers",
    message: pickupOnlyNumbers,
  },
  {
    id: "reverse",
    type: "only-numbers",
    message: reverseOnlyNumbers,
  },
  {
    id: "reverse",
    type: "required",
    message: reverseRequired,
  },
  {
    id: "end_date",
    type: "required",
    message: endDateRequired,
  },
  {
    id: "end_date",
    type: "future_date",
    message: endDateNotInThePast,
  },
];

const AndreaniCredentials = ({
  handleCancel,
  alert,
  carrier,
  loading,
  handleSubmitCarriers,
}: ICredentialsStep) => {
  const [credentials, setCredentials] = useState(
    {} as ICredentialsAndreaniPayload
  );
  const [errors, setErrors] = useState({} as ICredentialsAndreaniErrors);

  const handleSubmit = () => {
    const inputErrors = validateInputs(credentials, formValidations);
    const { b2c } = credentials;
    const d2dContract = !!(b2c);
    if (!d2dContract) {
      inputErrors.b2c = [oneDoorToDoorRequired];
    }

    setErrors(inputErrors);
    if (Object.keys(inputErrors).length === 0) {
      handleSubmitCarriers([
        {
          ...carrier,
          credentials,
        },
      ]);
    }
  };
  return (
    <>
      <Typography className="f-s-24 m-b-20">
        Credenciales de ANDREANI
      </Typography>
      {alert.showAlert && <GenericAlert alert={alert} />}
      <CredentialsAndreani
        values={credentials}
        setValues={setCredentials}
        errors={errors}
      />
      <ConfirmChangesCredentials
        onClose={handleCancel}
        handleSubmit={handleSubmit}
        disabled={loading}
        backText="Cambiar operador"
        confirmText="Finalizar"
      />
    </>
  );
};

export default AndreaniCredentials;
